import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useOctoberRosa } from "@/hooks/useOctoberRosa";
import { useBlackFriday } from "@/hooks/useBlackFriday";

const items: Array<string | { label: string; href: string }> = [
  "Notificado na ANVISA",
  "Sem perfume",
  "Cruelty-Free · Sem Testes em Animais",
  "Dermatologicamente Testado",
  "Hipoalergênico",
  { label: "Não gostou? Devolvemos 100% em 7 dias", href: "/garantia" },
  "Frete grátis para todo o Brasil",
  "10% na 1ª compra · cupom PRIMEIRA10",
];

export const AnnouncementBar = () => {
  const octoberRosa = useOctoberRosa();
  const blackFriday = useBlackFriday();
  const seasonalItems = [
    ...items,
    ...(octoberRosa ? ["Outubro Rosa · Cuidar da pele é cuidar da vida. Faça seu autoexame e converse com seu médico."] : []),
    ...(blackFriday ? ["Black Friday · 15% com o cupom BLACKHOF15 em pedidos a partir de R$ 120"] : []),
  ];
  // Duplicate the list so the marquee loops seamlessly
  const loop = [...seasonalItems, ...seasonalItems];

  return (
    <div
      className="w-full overflow-hidden border-b"
      style={{
        backgroundColor: "#F1F4F8",
        borderColor: "rgba(61, 82, 116, 0.08)",
        height: "36px",
      }}
      aria-label="Selos e diferenciais NAT HOF"
    >
      <div className="relative h-full flex items-center">
        <div
          className="flex shrink-0 whitespace-nowrap will-change-transform"
          style={{
            animation: "announcement-marquee 90s linear infinite",
          }}
        >
          {loop.map((item, i) => {
            const label = typeof item === "string" ? item : item.label;
            const href = typeof item === "string" ? undefined : item.href;
            return (
            <span
              key={`${label}-${i}`}
              className="inline-flex items-center gap-2 px-6"
              style={{
                color: "#3D5274",
                fontSize: "12px",
                fontWeight: 400,
                letterSpacing: "0.01em",
              }}
            >
              <Check className="w-3 h-3 opacity-60" strokeWidth={2.5} />
              {href ? (
                <Link to={href} className="underline underline-offset-2 hover:opacity-80">{label}</Link>
              ) : (
                <span>{label}</span>
              )}
              <span className="ml-6 opacity-30" aria-hidden>·</span>
            </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
